<template>
  <div>
    <v-container>
      <h1 class="hl">
        Willkommen im Portal zur <br class="d-none d-lg-block" />Erfassung von
        Wassernutzungen im Bereich des Erftverbandes, <br />{{
          address + ' ' + username
        }}
      </h1>
      <v-sheet elevation="1" class="pa-12 mt-8">
        <v-row dense>
          <v-col class="justify-end d-flex">
            <a :href="hrefAttr" rel="noreferrer" target="_blank">E-Mail an den Erftverband</a>
          </v-col>
        </v-row>
        <template v-if="currentCategories.length">
          <v-row dense>
            <v-col md="3">
              <h3>Aktuelle Formulare zur diesjährigen Bearbeitung</h3>
            </v-col>
          </v-row>
          <v-container fluid v-for="category in currentCategories" :key="category.id" class="ps-0">
            <h4>{{ category.name }}</h4>
            <v-row dense v-for="betrieb in category.betriebe" :key="betrieb.name">
              <v-col cols="12" sm="4" class="d-flex align-center" v-if="Object.keys(betrieb.forms).length > 0">
                <span>{{ betrieb.name }} ({{ betrieb.mitglied }})</span>
              </v-col>
              <v-col v-for="form in betrieb.forms" :key="form.id" class="d-flex">
                <v-btn @click="handleFormClick(form)" :color="form.status === 'pruefung' || form.status === 'erste_freigabe'
                  ? 'primary'
                  : form.status === 'freigegeben'
                    ? 'green'
                    : form.status === 'korrektur'
                      ? 'error'
                      : 'nicht ausgefüllt'
                        ? 'yellow'
                        : ''
                  " class="form__btn">
                  {{ form.year }}
                </v-btn>
                <v-btn depressed icon>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on: tooltip }">
                      <v-icon v-on="{ ...tooltip }">mdi-calendar-edit </v-icon>
                    </template>
                    <span>zuletzt bearbeitet: {{ form.lastChanged }}</span><span v-if="form.lastChangedUser">
                      von: {{ form.lastChangedUser }}</span>
                  </v-tooltip>
                </v-btn>
                <v-btn depressed icon>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on: tooltip }">
                      <v-icon v-on="{ ...tooltip }">
                        mdi-email-fast-outline
                      </v-icon>
                    </template>
                    <div v-html="form.mailHistory"></div>
                  </v-tooltip>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </template>
        <hr v-if="currentCategories.length && categories.length">
        <template v-if="categories.length">
          <v-row dense>
            <v-col md="3">
              <h3>Vergangene Formulare - keine Bearbeitung mehr möglich</h3>
            </v-col>
          </v-row>
          <v-container fluid v-for="category in categories" :key="category.id" class="ps-0">
            <h4>{{ category.name }}</h4>
            <v-row dense v-for="betrieb in category.betriebe" :key="betrieb.name">
              <v-col cols="12" sm="4" class="d-flex align-center" v-if="Object.keys(betrieb.forms).length > 0">
                <span>{{ betrieb.name }} ({{ betrieb.mitglied }})</span>
              </v-col>
              <v-col v-for="form in betrieb.forms" :key="form.id" class="d-flex">
                <v-btn @click="handleFormClick(form)" :color="form.status === 'pruefung' || form.status === 'erste_freigabe'
                  ? 'primary'
                  : form.status === 'freigegeben'
                    ? 'green'
                    : form.status === 'korrektur'
                      ? 'error'
                      : 'nicht ausgefüllt'
                        ? ''
                        : ''
                  " class="form__btn">
                  {{ form.year }}
                </v-btn>
                <v-btn depressed icon>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on: tooltip }">
                      <v-icon v-on="{ ...tooltip }">mdi-eye-outline </v-icon>
                    </template>
                    <span>zuletzt bearbeitet: {{ form.lastChanged }}</span><span v-if="form.lastChangedUser">
                      von: {{ form.lastChangedUser }}</span>
                  </v-tooltip>
                </v-btn>
                <v-btn depressed icon>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on: tooltip }">
                      <v-icon v-on="{ ...tooltip }">
                        mdi-email-fast-outline
                      </v-icon>
                    </template>
                    <div v-html="form.mailHistory"></div>
                  </v-tooltip>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </template>
        <v-row>
          <v-col class="d-flex align-center">
            <v-icon color="#f5f5f5">mdi-circle</v-icon><span> = nicht ausgefüllt</span>
          </v-col>
          <v-col class="d-flex align-center">
            <v-icon color="yellow">mdi-circle</v-icon><span> = aktuell und nicht ausgefüllt</span>
          </v-col>
          <v-col class="d-flex align-center">
            <v-icon color="primary">mdi-circle</v-icon><span> = in Prüfung</span>
          </v-col>
          <v-col class="d-flex align-center">
            <v-icon color="error">mdi-circle</v-icon><span> = Korrektur erforderlich</span>
          </v-col>
          <v-col class="d-flex align-center">
            <v-icon color="green">mdi-circle</v-icon><span> = abgeschlossen</span>
          </v-col>
          <v-col class="d-flex align-center">
            <v-icon>mdi-calendar-edit</v-icon><span> = letzte Bearbeitung</span>
          </v-col>
        </v-row>
      </v-sheet>
      <v-divider class="mt-5 mb-5"></v-divider>
    </v-container>
  </div>
</template>

<script>
import { getUserInfo } from '../../utils/auth';
import { mapState } from 'vuex';
import axios from '../../utils/api';
import helpers from '../helpers.js';
const { currentYear } = helpers;

export default {
  data: () => ({
    categories: [],
    currentCategories: [],
    address: '',
    mail: '',
    memberNo: '',
    addressData: {},
  }),
  computed: {
    ...mapState({
      username: (state) => state.username,
      usertype: (state) => state.usertype,
      showNavDrawer: (state) => state.showNavDrawer,
      addressDialog: (state) => state.addressDialog,
      firstLogin: (state) => state.firstLogin,
    }),
    hrefAttr() {
      const href =
        'mailto:statistik@erftverband.de?subject=Mitgliedsnummer: ' +
        this.memberNo;
      return href;
    },
  },
  mounted() {
    this.beforeLoad();
    this.$forceUpdate();
  },
  methods: {
    currentYear,
    async beforeLoad() {
      const userInfo = getUserInfo();
      const username = userInfo.ANSPRECH;
      const address = userInfo.ANSPRECH_ANREDE;
      this.address = address;
      this.$store.dispatch('setUser', username);
      this.memberNo = userInfo.MIMITGL;
      this.mail = userInfo.MAIL;
      try {
        let res = await axios({
          url: `/API-USER/dashboard?mail=${this.mail}&jahr=`,
          method: 'GET',
        });
        let data = res.data;
        this.addressData = {
          companyPart1: data[0].FIRMA1,
          companyPart2: data[0].FIRMA2,
          companyPart3: data[0].FIRMA3,
          companyPart4: data[0].FIRMA4,
          location1: data[0].BETRIEB1,
          location2: data[0].BETRIEB2,
          street: data[0].STRASSE,
          zip: data[0].PLZ,
          city: data[0].ORT,
          firstName: data[0].ANSPRECH_VN,
          title: data[0].ANSPRECH_ANREDE,
          lastName: data[0].ANSPRECH,
          tel: data[0].TELEFON,
          email: data[0].MAIL,
          companyPart11: data[0].FIRMA11 || "",
          companyPart12: data[0].FIRMA12 || "",
          companyPart13: data[0].FIRMA13 || "",
          companyPart14: data[0].FIRMA14 || "",
          street1: data[0].STRASSE1,
          zip1: data[0].PLZ1,
          city1: data[0].ORT1,
          mimitgl: data[0].MIMITGL,
        };
        this.$store.dispatch('setAddressData', this.addressData);
        if (this.firstLogin === true) {
          this.$store.commit('setAddressDialog', {
            show: true,
            persistent: true,
          });
        }
        console.log('res.data ', data);
        this.buildDashboard(data);
      } catch (err) {
        console.error('Dashboard Request Error:', err);
      }
    },
    buildDashboard(data) {
      data.forEach((el) => {
        const formattedDatetime = new Date(el.lastchange).toLocaleString(
          'de-DE'
        );
        let mailHistory = el.mailhistory;
        mailHistory = mailHistory.replaceAll(/<li>,/g, '<li>');
        mailHistory = mailHistory.replaceAll(
          /(\d{4})-(\d{1,})-(\d{1,})/g,
          '$3.$2.$1'
        ); // format dates
        const newForm = {
          year: el.BEFRAG,
          name: '',
          status: el.status,
          id: '',
          mitglied: decodeURI(el.MIMITGL),
          firma: el.FIRMA1,
          firma2: el.FIRMA2,
          firma3: el.FIRMA3,
          betrieb: el.BETRIEB1,
          lastChanged: formattedDatetime,
          lastChangedUser: el.lastchange_user,
          mailHistory: mailHistory,
        };
        let firmaCommaBetrieb = '';
        el.FIRMA1 ? (firmaCommaBetrieb += el.FIRMA1) : null;
        el.FIRMA2 ? (firmaCommaBetrieb += ', ' + el.FIRMA2) : null;
        el.FIRMA3 ? (firmaCommaBetrieb += ', ' + el.FIRMA3) : null;
        el.BETRIEB1 ? (firmaCommaBetrieb += ', ' + el.BETRIEB1) : null;
        let mitgliedsNr = decodeURI(el.MIMITGL);
        let category = "";
        if (el.FRAGEB_NR) {
          switch (el.FRAGEB_NR) {
            case '1':
              category = 'Öffentliche Wasserversorgung';
              newForm.name = 'form_oeff';
              break;
            case '2':
              category = 'Gewerbliche Betriebe';
              newForm.name = 'form_gew';
              break;
            case '3':
              category = 'Kies- und Betonwerke';
              newForm.name = 'form_kibe';
              break;
            case '4':
              category = 'Sport-/Freizeitanlagen';
              newForm.name = 'form_spofr';
              break;
            case '5':
              category = 'Landwirtschaft';
              newForm.name = 'form_land';
              break;
            default:
              return;
          }
          let destination = this.categories;
          if (this.isCurrentForm(newForm)) {
            destination = this.currentCategories;
          }
          if (!destination.some((e) => e.name === category)) {
            destination.push({ name: category, betriebe: {} });
          }
          destination.map((cat) => {
            if (cat.name === category) {
              if (!cat.betriebe[firmaCommaBetrieb]) {
                cat.betriebe[firmaCommaBetrieb] = {
                  name: firmaCommaBetrieb,
                  mitglied: mitgliedsNr,
                };
              }
              if (!cat.betriebe[firmaCommaBetrieb].forms) {
                cat.betriebe[firmaCommaBetrieb]['forms'] = {};
              }
              newForm.id =
                newForm.name +
                (Object.keys(cat.betriebe[firmaCommaBetrieb].forms).length + 1);
              cat.betriebe[firmaCommaBetrieb].forms[newForm.id] = newForm;
            }
          });
  
          this.sortForms();
        }
      });
    },
    handleFormClick(form) {
      let firmaCommaBetrieb = '';
      form.firma ? (firmaCommaBetrieb += form.firma) : null;
      form.firma2 ? (firmaCommaBetrieb += ', ' + form.firma2) : null;
      form.firma3 ? (firmaCommaBetrieb += ', ' + form.firma3) : null;
      form.betrieb ? (firmaCommaBetrieb += ', ' + form.betrieb) : null;
      this.$store.commit('setFirmaCommaBetrieb', firmaCommaBetrieb);
      this.$store.commit('setMitglied', form.mitglied);
      if (form.name === 'form_spofr' && form.mitglied.startsWith('5')) {
        this.$router.push({
          name: form.name + '_land',
          params: { username: form.mitglied, year: form.year },
        });
      } else {
        this.$router.push({
          name: form.name,
          params: { username: form.mitglied, year: form.year },
        });
      }
    },
    sortForms() {
      for (const cat of this.categories) {
        for (const [key, value] of Object.entries(cat.betriebe)) {
          value.forms = Object.fromEntries(Object.entries(value.forms).sort(([, a], [, b]) => { return b.year - a.year; }));
        }
      }
    },
    isCurrentForm(form) {
      if (form.year == this.currentYear()) {
        return true;
      }
      return false;
    }
  },
};
</script>

<style scoped>
hr {
  margin: 1rem 0;
}
</style>